/**
 * 当前有 4 个新手引导流程
 * 0. 新版本功能介绍
 * 1. 基础功能
 * 2.1 (我的 OKR 页面）
 * 2.1.1 目标上对齐
 * 2.2 （他人 OKR 页面）
 * 2.2.1 对齐他人
 */
import storage from 'store'
import { CHECK_GUIDE_STEP, CHECK_CONDITION, CHECK_GUIDE_VERSION } from '../mutation-types'

import { version } from '@/constants/guide'

const GUIDED_KEY = 'guidedSteps'
const GUIDED_VERSION_KEY = 'guidedVersion'

const guidedSteps = storage.get(GUIDED_KEY, [])

const state = {
  isNewVersionGuided: storage.get(GUIDED_VERSION_KEY) === version,
  isLayoutGuided: guidedSteps.includes('isLayoutGuided'), // 基础功能是否已经引导
  isMyOkrObjectiveAlignGuided: guidedSteps.includes('isMyOkrObjectiveAlignGuided'), // 我的 OKR 页面目标对齐是否已经引导
  isMyOkrKeyResultGuided: guidedSteps.includes('isMyOkrKeyResultGuided'), // 我的 OKR 页面关键目标是否已经引导
  isOtherOkrAlignGuided: guidedSteps.includes('isOtherOkrAlignGuided'), // 他人 OKR 页面目标对齐是否已经引导
  isMyObjectiveCreated: false, // 我的目标是否已经创建
  isOtherOkrObjectiveCreated: false // 他人的目标是否已经创建
}

const mutations = {
  [CHECK_GUIDE_STEP] (state, guideName) {
    state[guideName] = true
    const guidedSteps = storage.get(GUIDED_KEY, [])
    storage.set(GUIDED_KEY, [
      ...guidedSteps,
      guideName
    ])
  },
  [CHECK_CONDITION] (state, conditionName) {
    state[conditionName] = true
  },
  [CHECK_GUIDE_VERSION] (state) {
    state.isNewVersionGuided = true
    storage.set(GUIDED_VERSION_KEY, version)
  }
}

const actions = {
  checkGuideStep ({ commit }, guideName) {
    commit(CHECK_GUIDE_STEP, guideName)
  },
  checkGuidedVersion ({ commit }) {
    commit(CHECK_GUIDE_VERSION)
  }
}

export default {
  state,
  mutations,
  actions
}
